import React from 'react';
import {Logo} from "../../../../../../core/components/logo-icon/logo";
import {observer} from 'mobx-react';
import styles from "../../styles/footer.module.scss";
import classNames from "classnames";
import {FOOTER_MODULE} from "../../footer-module.consts";
import {FooterModuleBettingDisclosure} from "../footer-module.betting-disclosure";

export const FooterModuleDesktopTopLogoDescription = observer(({controller}) => {
  const {state} = controller;
  const {description} = state;

  const logoProps = {
    width: FOOTER_MODULE.LOGOS.MAIN.width,
    height: FOOTER_MODULE.LOGOS.MAIN.height,
    className: classNames(styles.top_content_logo),
    style: {
      width: FOOTER_MODULE.LOGOS.MAIN.width
    }
  }

  return (
    <div className={classNames(styles.top_content_description)}>
      <Logo {...logoProps}/>
      <div className={classNames(styles.top_content_description_text)}>
        {
          description
        }
        <FooterModuleBettingDisclosure controller={controller}/>
      </div>

    </div>
  );
})
